// configureStore.ts
import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../slices/authSlice';
import rightSideAdReducer from '../slices/rightSideAd';
import dashboardReducer from '../slices/dashboardSlice';
import indicationReducer from '../slices/indication';
import virtualClassRoomReducer from '../slices/virtualClassRoomSlice'
import JitsiMeetSlice from '../slices/JitsiMeetSlice';
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";

const dashboardPersistConfig = {
  key: "dashboard",
  storage,
};

const persistedDashboardReducer = persistReducer(dashboardPersistConfig, dashboardReducer);

const createStore = () => {
  return configureStore({
    reducer: {
      auth: authReducer,
      rightSideAd: rightSideAdReducer,
      dashboard: persistedDashboardReducer,
      indication: indicationReducer,
      virtualClassRoom: virtualClassRoomReducer,
      JitsiMeetSlice: JitsiMeetSlice
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
      serializableCheck: false
    }),
  });
};

export const store = createStore();
export const persistor = persistStore(store);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;